import type { Config } from '@/config/types.ts'; // 测试环境配置

// 测试环境配置
const config: Partial<Config> = {};

export default config;
